import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/ProductShow.css';
import ls from 'local-storage'
import axios from 'axios';
import Retry from "./Retry";
import AppBody from "./AppBody";
import Product from "../Modules/Product";
import Comment from "../Modules/Comment";
import Comments from "./Comments";
class ProductShow extends React.Component{
    list =[];
    content = document.getElementsByClassName("content")[0];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            error: false,
            error_text: "",
            loading: true,
            title:"",
            description:"",
            text:"",
            price:"",
            oldprice:"",
            discounts:"",
            weight:"",
            url:null,
            unit:"",
            fav_status:0,
            product_number:"",
            amazing_remained_time:"",
            amazing:"",
            product:null,
            id:ls.get("product_id"),
            comments:[],
            CommentStatus:[],
            activeMenu:1

        };

    }

    componentWillMount = () => {
        if(ls.get("product_id") == null)
            this.props.history.push("/home");
        this.getProduct();
        this.getProductComments();
    };

    componentDidMount = () => {
        if(ls.get("list"))
            this.list = ls.get("list");
        if(this.list  != null && this.list.length > 0)
            this.setState({buy_list:this.list});
    };
    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );


        let buy_btn = "";
        if(this.state.product_number == -1)
            buy_btn = (<button className={"productShowBtn_close"}>بسته است</button>)
        else if(this.state.product_number == 0)
            buy_btn = (<button className={"productShowBtn_close"}>تمام شد</button>)
        else if(!this.list.some(el=>el.product_id === this.state.id)) {
            buy_btn = (<button id={"productShowBtn_buy"} onClick={()=>this.addProductToList(this.state.id)} > خرید </button>)
        }
        else{
            let index = this.list.findIndex((cart=>cart.product_id === this.state.id));
            buy_btn = (
                <div id={"productShowBuyDiv"}>
                    <button id={"productShowAdd_amount"}  onClick={()=>this.addProductToList(this.state.id)}><i className={"glyphicon glyphicon-plus "}/></button>
                    <label id={"productShowAmount"}>{this.state.buy_list[index].product_number + this.getProductUnit(this.state.unit)}</label>
                    <button id={"productShowSub_amount"}  onClick={()=>this.subProductToList(this.state.id)} ><i className={"glyphicon glyphicon-minus "}/></button>
                </div>
            )
        }
        return (
            <AppBody loading={this.state.loading} name={"مشاهده محصول"} type={" bg-white"}>
                <div id={"ProductShowSlider"}>
                    <img className={"ProductShowSliderImg"}  src={(this.state.url != null)?urls.SiteUrl+"upload/"+this.state.url:`${process.env.PUBLIC_URL}/assets/images/blank.png`}/>
                    <img className={"productFav"} onClick={this.setProductFav} src={(this.state.fav_status == 1)?`${process.env.PUBLIC_URL}/assets/images/favon.png`:`${process.env.PUBLIC_URL}/assets/images/favoff.png`}/>
                </div>
                <div id={"productShowTitle"}>{this.state.title}</div>
                <div id={"productShowPrice"}>قابل پرداخت : {new Intl.NumberFormat("fa").format(this.state.price)} تومان</div>
                {buy_btn}
                <div id={"ProductShowNavRow"}>
                    <button className={"ProductShowCategory"+((this.state.activeMenu === 0)?" active":"")} onClick={(e)=>this.switchTabs(e,this,0)}>نظرات</button>
                    <button className={"ProductShowCategory"+((this.state.activeMenu === 1)?" active":"")} onClick={(e)=>this.switchTabs(e,this,1)}>توضیحات</button>
                </div>
                {this.tabRender()}
            </AppBody>
        );
    }

    tabRender(){

        if(this.state.activeMenu == 1)
            return (
                <div id={"ProductShowArea"}>
                   <div  dangerouslySetInnerHTML={{__html: this.state.description}}  id={"productShowDescription"}/>
                </div>);
        else if(this.state.activeMenu == 0)
            return (
                <Comments comments={this.state.comments}/>
            );

        return (
            <div id={"ProductShowArea"}>
                <div  dangerouslySetInnerHTML={{__html: this.state.description}}  id={"productShowDescription"}/>
            </div>);
    };
    switchTabs(event,elm,type){
        let navs = document.getElementsByClassName("ProductShowCategory");
        for (let i = 0; i < navs.length; i++)
            navs[i].className = "ProductShowCategory";
        event.target.className += " active";
        this.setState({activeMenu:type});
    }
    getProduct=()=>{
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.getProduct+"?id="+this.state.id+"&token="+ls.get("token"))
            .then(res => {
                if(res.data.code == 200){
                    let product = new Product(res.data.data);
                    product.product_discounts =res.data.data.discounts;
                    product.product_description =res.data.data.description;
                    product.product_id =this.state.id;
                    product.product_image =res.data.data.url;
                    product.product_price =res.data.data.price;
                    product.product_name =res.data.data.title;
                    product.store_name =res.data.data.stores.store_name;
                    this.setState({
                        title:res.data.data.title,
                        description:res.data.data.description,
                        text:res.data.data.text,
                        price:res.data.data.price,
                        oldprice:res.data.data.oldprice,
                        discounts:res.data.data.discounts,
                        weight:res.data.data.weight,
                        url:res.data.data.url,
                        unit:res.data.data.unit,
                        fav_status:res.data.data.fav_status,
                        product_number:res.data.data.product_number,
                        amazing_remained_time:res.data.data.amazing_remained_time,
                        amazing:res.data.data.amazing,
                        product:product,
                        loading:false
                    });
                }
                else{
                    this.setState({loading:false});
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({retry:true,loading:false});
            });
    };
    getProductComments(){
        this.setState({loading:true});
        let data = {
            token:ls.get("token"),
            id:this.state.id,
            comments_of:1,
        };
        axios.post(urls.baseUrl+urls.getComments,data)
            .then(res => {
                if(res.data.code == 200){
                    let comments = [];
                    res.data.comments.forEach((item)=>{
                        comments.push(new Comment(item));
                    });
                    this.setState({
                        comments:comments,
                        CommentStatus:res.data.CommentStatus,
                        loading:false});
                }
                else{
                    alert(res.data.message)
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({retry:true,loading:false});
            });
    }
    setProductFav=()=>{
        this.setState({loading:true});
        let data = {
            token: ls.get("token"),
            product_id:this.state.id
        };
        axios.post(urls.baseUrl+urls.product_fav,data)
            .then(res => {
                if(res.data.code == 200){
                    this.setState({
                        fav_status:(res.data.add_or_remove == 1)?1:0,
                        loading:false
                    });
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({retry:true,loading:false});
            });
    }

    addProductToList=(id)=>{
        if(this.list  == null)
            this.list  = [];
        let found = this.list.some(el=>el.product_id === id);
        let product_number = this.state.product_number;
        if(!found){
            let clone = Object.assign({},this.state.product);
            this.list.push(clone);
            this.list[this.list.length-1].product_number = 1;
            this.list[this.list.length-1].product_max_number = product_number;
        }
        else{
            let index = this.list.findIndex((cart=>cart.product_id === id));
            if(product_number == null || product_number > this.list[index].product_number)
                this.list[index].product_number +=1;
        }

        ls.set("list",this.list);
        this.setState({buy_list:this.list});
    };
    subProductToList(id){
        let found = this.list.some(el=>el.product_id === id);
        if(found){
            let index = this.list.findIndex((cart=>cart.product_id === id));
            this.list[index].product_number -=1;
            if(this.list[index].product_number <= 0)
                this.list.splice(index,1);
        }

        ls.set("list",this.list);
        this.setState({buy_list:this.list});
    }
    getProductUnit(unit){
        switch (unit) {
            case 'gram':return" گرم";
            case 'kg':return" کیلوگرم";
            case 'nimkilo':return" نیم کیلو";
            case 'number':return" عدد";
            case 'pors':return" پرس";
            default:return " عدد";
        }
    }
}



export default ProductShow;
